const _DEFAULT_DOT_COM_NAV_URL = "https://www.cmegroup.com/files/js/loader.js";

const appendScript = (options) => {
    const script = document.createElement("script");
    const keys = Object.keys(options);
    for (let i = 0; i < keys.length; i++){
        const key = keys[i];
        script[key] = options[key];
    }
    document.body.appendChild(script);
    return script;
};

const fixLinks = ($, baseDotComUrl = "https://www.cmegroup.com") => {
    $("#cme-header,#cme-footer").click(e => {
        if (e.target.href){
            const $a = $(e.target);
            // why not using e.target.href? Because the browser actually resolves the URL in e.target.href.
            const href = $a.attr("href");
            if (href && href.indexOf("/") === 0) {
                // it's a relative URL, prefix it with .com
                e.preventDefault();
                window.location.href = baseDotComUrl + href;
            }
        }
    });
};

const DOT_COM_NAV_STYLE = `<style type="text/css">
    .cme-styles .navbar { +
            box-shadow: 0 2px 4px 0 rgb(0 0 0 / 20%)!important;
    }
    #cme-header .nav-login {
            display: none!important;
    }
    .cme-styles .modal.show {
        visibility: visible;
    }
    .cme-styles .modal {
        position: fixed;
        top: 0px;
        left: 0px;
        z-index: 1050;
        display: none;
        overflow: hidden;
        outline: 0px;
        max-height:none;
        max-width:none;
        transform:none;
        background:transparent; 
    } 
    </style>
    `
;

const addStyles = ($) => {
    $("head").append(DOT_COM_NAV_STYLE);    
};

const renderDotComNav = (jqueryPath, loaderFile, baseDotComUrl) => {
    let myLoaderFile;
    if (! loaderFile || loaderFile.length === 0){
        myLoaderFile = _DEFAULT_DOT_COM_NAV_URL;
    } else {
        myLoaderFile = loaderFile;
    }

    // load jquery
    appendScript({src: jqueryPath}).onload = () => {
        // jQuery will be loaded at this point
        appendScript({src: myLoaderFile});
        const $ = jQuery;
        fixLinks($, baseDotComUrl);
        addStyles($);
    };
};

export default renderDotComNav;